import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getDashboardPendaftarPeriode = createAsyncThunk("dashboard/dataPendaftar/periodeGelombang", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/data_pendaftar/periode_gelombang`);
    return response.data;
});

export const getDashboardPendaftarTopSekolah = createAsyncThunk("dashboard/dataPendaftar/topSekolah", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/data_pendaftar/top_sekolah`);
    return response.data;
});

export const getDashboardPendaftarProdi = createAsyncThunk("dashboard/dataPendaftar/prodi", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/data_pendaftar/prodi`);
    return response.data;
});

export const getDashboardPendaftarProdiPeriode = createAsyncThunk("dashboard/dataPendaftar/prodiPeriode", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/data_pendaftar/prodi_periode`);
    return response.data;
});

export const getDashboardPendaftarDaftarUlang = createAsyncThunk("dashboard/dataPendaftar/daftarUlang", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/data_pendaftar/daftar_ulang`);
    return response.data;
});

const initialState = {
    loadingPeriode : false,
    responsePeriode : [],
    loadingTopSekolah : false,
    responseTopSekolah : [],
    loadingProdi : false,
    responseProdi : [],
    loadingProdiPeriode : false,
    responseProdiPeriode : [],
    loadingDaftarUlang : false,
    responseDaftarUlang : []
}

const dashDataPendaftarSlice = createSlice({
    name:"dashDataPendaftarSlice",
    initialState: initialState,
    extraReducers: {
        [getDashboardPendaftarPeriode.pending] : (state, action) => {
            state.loadingPeriode = true;
        },
        [getDashboardPendaftarPeriode.fulfilled] : (state, action) => {
            state.responsePeriode = action.payload;
            state.loadingPeriode = false;
        },
        [getDashboardPendaftarPeriode.rejected] : (state, action) => {
            state.loadingPeriode = false;
        },
        [getDashboardPendaftarTopSekolah.pending] : (state, action) => {
            state.loadingTopSekolah = true;
        },
        [getDashboardPendaftarTopSekolah.fulfilled] : (state, action) => {
            state.responseTopSekolah = action.payload;
            state.loadingTopSekolah = false;
        },
        [getDashboardPendaftarTopSekolah.rejected] : (state, action) => {
            state.loadingTopSekolah = false;
        },
        [getDashboardPendaftarProdi.pending] : (state, action) => {
            state.loadingProdi = true;
        },
        [getDashboardPendaftarProdi.fulfilled] : (state, action) => {
            state.responseProdi = action.payload;
            state.loadingProdi = false;
        },
        [getDashboardPendaftarProdi.rejected] : (state, action) => {
            state.loadingProdi = false;
        },
        [getDashboardPendaftarProdiPeriode.pending] : (state, action) => {
            state.loadingProdiPeriode = true;
        },
        [getDashboardPendaftarProdiPeriode.fulfilled] : (state, action) => {
            state.responseProdiPeriode = action.payload;
            state.loadingProdiPeriode = false;
        },
        [getDashboardPendaftarProdiPeriode.rejected] : (state, action) => {
            state.loadingProdiPeriode = false;
        },
        [getDashboardPendaftarDaftarUlang.pending] : (state, action) => {
            state.loadingDaftarUlang = true;
        },
        [getDashboardPendaftarDaftarUlang.fulfilled] : (state, action) => {
            state.responseDaftarUlang = action.payload;
            state.loadingDaftarUlang = false;
        },
        [getDashboardPendaftarDaftarUlang.rejected] : (state, action) => {
            state.loadingDaftarUlang = false;
        },
    }
})

export const dashDataPendaftarSelector = (state) => state.dashDataPendaftar;
export default dashDataPendaftarSlice.reducer;
